import "./organization-banner-image-edit-image.scss";
import React, { useEffect } from "react";
import { GSForm, GSSidePanelPage } from "golfstatus_react_components";
import { faChevronLeft, faUndoAlt } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { useFormDataValidation, useImageCropper } from "../../hooks/formHooks";
import {
  selectCurrentOrganization,
  setSelectedOrganization,
} from "../../reducers/organizationSlice";
import { useNavigate } from "react-router-dom";
import { getOrgBannerImageEditForm } from "../../forms/OrganizationForm";
import { setCroppedImage } from "../../reducers/utilitySlice";

const OrganizationBannerImageEditImage = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const currentOrganization = useSelector(selectCurrentOrganization);
  const property = "bannerImage";

  const [context, isValid] = useFormDataValidation({
    initialValid: true,
    data: currentOrganization,
    setData: setSelectedOrganization,
  });

  const [
    croppedImg,
    showCroppedImage,
    saveCroppedLogo,
    applyCrop,
    undoCrop,
    croppedImgBlob,
  ] = useImageCropper(context, property);

  useEffect(() => {
    const editor = document.getElementById("image-editor");
    editor.focus();
  }, []);

  const getDrawerActions = () => {
    let actions = [
      {
        name: "Save",
        isDisabled: !isValid,
        action: saveLogo,
        type: "black",
      },
      { name: "cancel", action: leftNavigation, type: "grey" },
    ];
    return actions;
  };

  const saveLogo = () => {
    dispatch(setCroppedImage(croppedImg));
    saveCroppedLogo();
    leftNavigation();
  };

  const leftNavigation = () => {
    navigate(-1);
  };

  const getNavigation = () => {
    return {
      title: `Edit Banner Image`,
      leftIcon: faChevronLeft,
      leftButtonClick: leftNavigation,
    };
  };

  context.getActions = () => {
    if (!showCroppedImage) {
      return [
        { buttonTitle: "Preview", actionClick: applyCrop, type: "transparent" },
      ];
    } else {
      return [
        {
          buttonTitle: "revert",
          actionIcon: faUndoAlt,
          actionClick: undoCrop,
          type: "transparent red",
        },
      ];
    }
  };

  context.getLogo = () => {
    return currentOrganization?.[property];
  };

  const getContent = () => {
    return (
      <GSForm
        formTitle="Edit Image"
        formActions={context.getActions()}
        formSections={getOrgBannerImageEditForm(
          context,
          showCroppedImage,
          croppedImg
        )}
      ></GSForm>
    );
  };

  const getDrawer = () => {
    return {
      actions: getDrawerActions(),
    };
  };

  const keyPressed = () => {
    saveLogo();
  };

  return (
    <organization-banner-image-edit-image
      id="image-editor"
      onKeyPress={keyPressed}
      tabIndex={1}
    >
      <GSSidePanelPage
        header={getNavigation()}
        content={getContent()}
        drawer={getDrawer()}
        loading={croppedImgBlob === undefined}
        loadingText={"Loading Image..."}
      ></GSSidePanelPage>
    </organization-banner-image-edit-image>
  );
};

export default OrganizationBannerImageEditImage;
